import React from "react"

import styles from "./hero-home.module.css"

export default function HeroHome({ children }) {
  return <div className={styles.hero}>{children}</div>
}
